import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSelectAllExitIntents = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(() => dispatch({ type: 'SET_CAMPAIGN_ALL_EXIT_INTENTS' }), [dispatch]);
};
